import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'dateTimezone'
})
export class DateTimezonePipe implements PipeTransform {
  transform(utcDate: string): string {
    if (utcDate == undefined || utcDate == null || utcDate === '') {
      return '--';
    }

    // Get user local timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Convert utc date into user local time
    return new Date(utcDate).toLocaleString('en-US', { timeZone: timezone });
  }
}
